import { AfterViewInit, ChangeDetectorRef, Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { EfficiencyAnalysisMarkerService } from '@app/energy-map/services/efficiency-analysis-marker.service';
import { AuthService } from '@app/shared/services/auth.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-building-icon',
  templateUrl: './building-icon.component.html',
  styleUrls: ['./building-icon.component.scss'],
})
export class BuildingIconComponent implements AfterViewInit, OnChanges, OnDestroy {
  protected unsubscribe$: Subject<void> = new Subject<void>();
  @Input() isMeterLicensed: boolean = false;
  @Input() alarmCount: number = 0;
  @Input() badgeVisible = true;
  @Input() iconImageUrl: string = '';
  @Input() isUnknownBuildingType: boolean = false;
  @Input() tooltipText: string = '';
  @Input() heatColorStatus: string = '';
  @Input() electricityColorStatus: string = '';
  @Input() hasLicensedMetersMunicipalityLvl: boolean = false;

  isEfficiencyDisabled: boolean = false;
  isBuildingHovered = false;

  constructor(public authService: AuthService, private efficiencyAnalysisMarker: EfficiencyAnalysisMarkerService, private ref: ChangeDetectorRef) {}

  public ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  public ngAfterViewInit(): void {
    this.efficiencyAnalysisMarker.isEfficiencyAnalysisDisabled$.pipe(takeUntil(this.unsubscribe$)).subscribe((x) => {
      this.toggleIsEfficiencyDisabled(x);
    });
  }

  public hoverLegendEvent(show: boolean): void {
    this.isBuildingHovered = show;
    this.ref.detectChanges();
  }

  public ngOnChanges(): void {
    this.ref.detectChanges();
  }

  private toggleIsEfficiencyDisabled = (disabled: boolean) => {
    this.isEfficiencyDisabled = disabled;
    this.ref.detectChanges();
  };
}
